import { MoreOptionsVerticalIcon as h, ListIcon as f, ImageIcon as m, DownloadIcon as y, ArticleIcon as g, ChartBarIcon as p, ShareIcon as I, QuoteIcon as b } from "@frontiers/brink-icons";
const w = 300, T = [
  "outline",
  "figures",
  "cite",
  "metrics",
  "share",
  "supplementaryMaterial"
], E = (t) => {
  const e = [];
  return t.hasOutline && e.push({
    targetId: "outline",
    titleToolbar: "Outline",
    icon: "ListIcon",
    title: "Outline",
    isHiddenMobile: !1
  }), t.hasFigures && e.push({
    targetId: "figures",
    titleToolbar: "Figures",
    icon: "ImageIcon",
    title: "Figures",
    isHiddenMobile: !1
  }), t.hasCite && e.push({
    targetId: "cite",
    titleToolbar: "Cite",
    icon: "QuoteIcon",
    title: "Cite article",
    isHiddenMobile: !1
  }), t.hasShare && e.push({
    targetId: "share",
    titleToolbar: "Share",
    icon: "ShareIcon",
    title: "Share article",
    isHiddenMobile: !1
  }), t.hasMetrics && e.push({
    targetId: "metrics",
    titleToolbar: "Metrics",
    icon: "ChartBarIcon",
    title: "Article metrics",
    isHiddenMobile: !1
  }), t.hasSupplementaryMaterial && e.push({
    targetId: "supplementaryMaterial",
    titleToolbar: "Suppl. material",
    icon: "ArticleIcon",
    title: "Supplementary material",
    isHiddenMobile: !1
  }), e;
}, L = (t) => {
  switch (t) {
    case "QuoteIcon":
      return b;
    case "ShareIcon":
      return I;
    case "ChartBarIcon":
      return p;
    case "ArticleIcon":
      return g;
    case "DownloadIcon":
      return y;
    case "ImageIcon":
      return m;
    case "ListIcon":
      return f;
    case "MoreOptionsVerticalIcon":
      return h;
  }
}, D = (t, e) => t.find(
  (o) => o.targetId === e
), O = (t) => {
  let e = !1;
  return T.forEach((o) => {
    t === `#${o}` && (e = !0);
  }), e;
}, d = () => w, V = () => d() * 1e-3, v = "data-scroll-top";
let i, l, s;
const n = 400, r = [];
let a = null;
const k = (t) => {
  for (let e = r.length; e >= 0; e--)
    if (r[e] === t) {
      r.splice(e, 1);
      break;
    }
}, S = () => {
  const t = document.documentElement.scrollHeight, e = window.innerHeight;
  return t > e;
}, A = (t) => {
  if (typeof t.value != "boolean")
    throw new Error(
      "The binding of lock-scroll directive must be a boolean value."
    );
}, M = () => {
  if (i.getAttribute("lock-scroll") === "true")
    return;
  const e = S();
  if (window.scrollY) {
    const o = window.pageYOffset;
    s.style.top = `${-o}px`, l.setAttribute("data-scroll-top", o.toString());
  } else
    l.setAttribute("data-scroll-top", "");
  s.style.display = "block", l.style.height = "100%", l.style.width = "100%", l.style.overflow = "hidden", l.style.position = "fixed", i.style.height = "100%", i.style.overflowY = e ? "scroll" : "hidden", i.style.overflowX = "hidden";
}, C = () => {
  const t = l.getAttribute(v);
  l.style.height = "", l.style.width = "", l.style.overflow = "", l.style.position = "", l.style.paddingRight = "", i.style.height = "", i.style.overflow = "", s.style.top = "", s.style.display = "", t && (window.scrollTo(0, parseInt(t, 10)), window.setTimeout(() => {
    l.setAttribute("data-scroll-top", "");
  }, 0));
}, B = () => {
  const t = document.querySelectorAll(
    "body > *:not(script):not(noscript)"
  ), e = [];
  if (t.length === 0)
    throw new Error(
      "[directive:lock-scroll] no children of body have been found"
    );
  for (let o = 0; o < t.length; o++)
    getComputedStyle(t[o]).position === "relative" && e.push(t[o]);
  if (e.length === 0)
    throw new Error(
      "[directive:lock-scroll] no valid children of body with relative position have been found"
    );
  return e.length > 1 && console.warn(
    "[directive:lock-scroll] serveral elements with position relative have been found. The directive will use the first one to lock the scroll."
  ), e[0];
}, c = (t, e) => {
  if (u(), e.value === !0) {
    if (clearTimeout(a), r.push(t), r.length === 1) {
      const o = e.modifiers.initialDelay === !0 ? n : e.modifiers.initialMiddleDelay ? n * 0.5 : 0;
      a = setTimeout(function() {
        M(), i.setAttribute("lock-scroll", "true");
      }, o);
    }
  } else if (k(t), r.length === 0) {
    const o = e.modifiers.noDelay === !0 ? 0 : e.modifiers.backMiddleDelay ? n * 0.5 : e.modifiers.backDelayInfoDrawer ? d() : n;
    a = setTimeout(function() {
      C(), i.setAttribute("lock-scroll", "false");
    }, o);
  }
}, u = () => {
  s || (i = document.getElementsByTagName("html")[0], l = document.getElementsByTagName("body")[0], s = B());
}, R = {
  mounted(t, e) {
    A(e), u(), e.value === !0 && c(t, e);
  },
  updated(t, e) {
    e.oldValue !== e.value && c(t, e);
  },
  unmounted(t) {
    c(t, { value: !1, modifiers: {} });
  }
};
export {
  R as B,
  D as a,
  L as b,
  V as c,
  E as d,
  d as g,
  O as v
};
